import { render, staticRenderFns } from "./birthdate.vue?vue&type=template&id=f04dcdcc&scoped=true&"
import script from "./birthdate.vue?vue&type=script&lang=ts&"
export * from "./birthdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04dcdcc",
  null
  
)

export default component.exports